import { type ReactNode } from "react";
import { PublicSiteHeader } from "@/components/layout/public-site-header";
import { SiteLegalFooter } from "@/components/layout/site-legal-footer";

export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="dd-public-page min-h-screen bg-white text-gray-900 flex flex-col">
      <PublicSiteHeader variant="marketing" />
      <main className="flex-1">{children}</main>
      <SiteLegalFooter className="border-t border-gray-100" />
    </div>
  );
}

